module.exports = __webpack_public_path__ + "media/app/assets/specializations/warlock/destruction-a93767819cb196450593e148a8f55dce.png";